import { createFileRoute } from '@tanstack/react-router'

import type { ShopPageKind } from '@/lib/api/shop-pages-api'
import { ListPageHeader } from '@/components/common/ListPageHeader'
import { PageEditor } from '@/components/retail/cms/page-editor'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/retail/pages/new')(
    {
        validateSearch: (
            s: Record<string, unknown>,
        ): { kind: ShopPageKind } => ({
            kind: s.kind === 'story' ? 'story' : 'page',
        }),
        component: NewPagePage,
    },
)

function NewPagePage() {
    const { kind } = Route.useSearch()
    const { hasPermission } = useAuth()
    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader
                title={
                    kind === 'story'
                        ? m.cmsPage_new_story()
                        : m.cmsPage_new_page()
                }
            />
            <PageEditor
                key={kind}
                kind={kind}
                canWrite={hasPermission('shop_content.write')}
            />
        </div>
    )
}
